document.addEventListener("DOMContentLoaded", () => {
  const slider = document.querySelector(".collection-gallery-type-3-slider");
  if (!slider) return;
  // Add this after selecting the slider element
  slider.style.willChange = "transform";
  slider.style.backfaceVisibility = "hidden";
  slider.style.perspective = "1000px";
  const originalCards = document.querySelectorAll(
    ".collection-gallery-type-3-card"
  );
  const track = document.querySelector(".collection-gallery-type-3-track");

  if (!slider || !track) return;

  // Function to enable video autoplay on mobile
  function enableVideoAutoplay() {
    slider.querySelectorAll("video").forEach((video) => {
      // Ensure videos are muted for autoplay to work
      video.muted = true;
      video.playsInline = true;

      // iOS requires this special attribute
      video.setAttribute("playsinline", "");
      video.setAttribute("webkit-playsinline", "");

      // Try to play and catch any errors
      const playPromise = video.play();

      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          // Fallback for browsers that block autoplay
          video.addEventListener("click", () => video.play(), { once: true });
        });
      }
    });
  }

  function setupSlider() {
    if (!slider) return;
    // Add these variables at the top of your setupSlider function
    let startX = 0;
    let startY = 0;
    let isHorizontalDrag = false;
    const DRAG_THRESHOLD = 10; // Increased threshold for better detection

    // Clear any existing clones
    while (slider.firstChild) {
      slider.removeChild(slider.firstChild);
    }

    // Quadruple cloning - 2 before and 2 after original cards
    const clonesBefore = [];
    const clonesAfter = [];

    // Clone before
    originalCards.forEach((card) => {
      const clone = card.cloneNode(true);
      clone.classList.add("clone"); // Add a class to identify clones
      clonesBefore.push(clone);
      slider.appendChild(clone);
    });

    // Add original cards
    originalCards.forEach((card) => {
      slider.appendChild(card.cloneNode(true));
    });

    // Clone after
    originalCards.forEach((card) => {
      const clone = card.cloneNode(true);
      clone.classList.add("clone"); // Add a class to identify clones
      clonesAfter.push(clone);
      slider.appendChild(clone);
    });

    const allCards = document.querySelectorAll(
      ".collection-gallery-type-3-card"
    );
    const realCardCount = originalCards.length;

    // Calculate card width including margin/padding
    const cardStyle = window.getComputedStyle(allCards[0]);
    const cardWidth =
      allCards[0].offsetWidth +
      parseInt(cardStyle.marginLeft) +
      parseInt(cardStyle.marginRight) +
      parseInt(cardStyle.paddingLeft) +
      parseInt(cardStyle.paddingRight);

    let currentIndex = clonesBefore.length; // Start at first original card
    let currentPosition = 0;
    let isDragging = false;
    let startPos = 0;
    let currentTranslate = 0;
    let animationId;

    // Function to calculate perfect center position
    function getCenterPosition() {
      const trackRect = track.getBoundingClientRect();
      const trackCenter = trackRect.left + trackRect.width / 2;
      return trackCenter;
    }

    // Function to center a specific card
    function centerCard(index) {
      const card = allCards[index];
      const cardRect = card.getBoundingClientRect();
      const cardCenter = cardRect.left + cardRect.width / 2;
      const trackCenter = getCenterPosition();

      currentPosition = currentPosition + (trackCenter - cardCenter);
      currentIndex = index;

      slider.style.transition =
        "transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)";
      slider.style.transform = `translateX(${currentPosition}px)`;
    }

    // Set initial position to show first original card centered
    setTimeout(() => {
      centerCard(clonesBefore.length);
    }, 50);

    // Calculate boundaries for instant restoration
    function getBoundaries() {
      const firstOriginalPos = -cardWidth * clonesBefore.length;
      const lastOriginalPos =
        -cardWidth * (clonesBefore.length + realCardCount - 1);
      return {
        left: firstOriginalPos - realCardCount * cardWidth,
        right: lastOriginalPos + realCardCount * cardWidth,
      };
    }

    // Check and restore position during drag
    function checkBoundariesDuringDrag() {
      const boundaries = getBoundaries();
      if (currentPosition > boundaries.right) {
        // Went too far right - jump to left clones
        currentPosition -= realCardCount * cardWidth;
        currentTranslate -= realCardCount * cardWidth;
        slider.style.transition = "none";
        slider.style.transform = `translateX(${currentPosition}px)`;
      } else if (currentPosition < boundaries.left) {
        // Went too far left - jump to right clones
        currentPosition += realCardCount * cardWidth;
        currentTranslate += realCardCount * cardWidth;
        slider.style.transition = "none";
        slider.style.transform = `translateX(${currentPosition}px)`;
      }
    }

    // Snap to nearest card
    function snapToCard() {
      const trackCenter = getCenterPosition();
      let closestCard = null;
      let minDistance = Infinity;

      allCards.forEach((card, index) => {
        const cardRect = card.getBoundingClientRect();
        const cardCenter = cardRect.left + cardRect.width / 2;
        const distance = Math.abs(cardCenter - trackCenter);

        if (distance < minDistance) {
          minDistance = distance;
          closestCard = index;
        }
      });

      if (closestCard !== null) {
        centerCard(closestCard);
      }
    }

    function touchStart(e) {
      // Only start drag if touch begins on the slider
      if (!e.target.closest(".collection-gallery-type-3-slider")) return;

      isDragging = true;
      startX = e.type.includes("touch") ? e.touches[0].clientX : e.clientX;
      startY = e.type.includes("touch") ? e.touches[0].clientY : e.clientY;
      currentTranslate = currentPosition;
      slider.style.transition = "none";
      cancelAnimationFrame(animationId);
    }

    // Replace your touchMove function
    function touchMove(e) {
      if (!isDragging) return;

      const currentX = e.type.includes("touch")
        ? e.touches[0].clientX
        : e.clientX;
      const currentY = e.type.includes("touch")
        ? e.touches[0].clientY
        : e.clientY;
      const diffX = currentX - startX;
      const diffY = currentY - startY;

      // Reduced threshold from 10px to 5px for more sensitive dragging
      const DRAG_THRESHOLD = 5;

      if (!isHorizontalDrag) {
        // Check if we've exceeded threshold
        if (
          Math.abs(diffX) > DRAG_THRESHOLD ||
          Math.abs(diffY) > DRAG_THRESHOLD
        ) {
          // Determine primary direction
          if (Math.abs(diffX) > Math.abs(diffY)) {
            isHorizontalDrag = true;
            e.preventDefault(); // Prevent scroll only when dragging horizontally
          } else {
            // Vertical scroll detected - cancel drag
            isDragging = false;
            return;
          }
        } else {
          // Haven't exceeded threshold yet
          return;
        }
      }

      // Only proceed if we're in horizontal drag mode
      currentPosition = currentTranslate + diffX;
      slider.style.transform = `translateX(${currentPosition}px)`;
      checkBoundariesDuringDrag();

      // Update current index
      animationId = requestAnimationFrame(() => {
        const trackCenter = getCenterPosition();
        allCards.forEach((card, index) => {
          const cardRect = card.getBoundingClientRect();
          const cardCenter = cardRect.left + cardRect.width / 2;
          if (Math.abs(cardCenter - trackCenter) < cardWidth / 2) {
            currentIndex = index;
          }
        });
      });
    }

    // Replace your touchEnd function
    function touchEnd() {
      if (!isDragging) return;

      isDragging = false;
      if (isHorizontalDrag) {
        snapToCard();
      }
      isHorizontalDrag = false;
    }

    // Update event listeners to use passive where possible
    slider.addEventListener("touchstart", touchStart, { passive: false });
    slider.addEventListener("mousedown", touchStart);
    slider.addEventListener("touchmove", touchMove, { passive: false });
    slider.addEventListener("mousemove", touchMove);
    slider.addEventListener("touchend", touchEnd, { passive: true });
    slider.addEventListener("mouseup", touchEnd);
    slider.addEventListener("mouseleave", touchEnd);
    // Handle window resize
    function handleResize() {
      // Re-center current card after resize
      centerCard(currentIndex);
    }

    window.addEventListener("resize", handleResize);

    // Cleanup function
    return () => {
      cancelAnimationFrame(animationId);
      window.removeEventListener("resize", handleResize);
      slider.removeEventListener("touchstart", touchStart);
      slider.removeEventListener("mousedown", touchStart);
      slider.removeEventListener("touchmove", touchMove);
      slider.removeEventListener("mousemove", touchMove);
      slider.removeEventListener("touchend", touchEnd);
      slider.removeEventListener("mouseup", touchEnd);
      slider.removeEventListener("mouseleave", touchEnd);
    };
  }
  let cleanup = null;

  function checkScreenSize() {
    if (!slider) return;
    if (window.innerWidth < 1000) {
      // Mobile/tablet behavior
      slider.style.display = "flex";
      slider.style.whiteSpace = "nowrap";
      if (!cleanup) {
        cleanup = setupSlider();
      }
    } else {
      // Desktop behavior
      slider.style.display = "grid";
      slider.style.transform = "none";
      slider.style.transition = "none";

      if (cleanup) {
        cleanup();
      }
    }
  }

  // Initial check
  checkScreenSize();
  // Enable video autoplay for all videos
  enableVideoAutoplay();
  // Add event listener for window resize
  window.addEventListener("resize", checkScreenSize);
});
